/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 *
 * @namespace classes.FunctionHelper
 */
const FunctionHelper = /** @lends classes.FunctionHelper*/ {
  debounce: function (func, threshold, execAsap) {
    let timeout = null;

    return function (...args) {
      const delayed = () => {
        if (!execAsap) {
          func.apply(this, args);
        }
        timeout = null;
      };

      if (timeout) {
        clearTimeout(timeout);
      } else if (execAsap) {
        func.apply(this, args);
      }

      timeout = setTimeout(delayed, threshold || 100);
    };
  },

  /**
   * @param func
   * @param threshold
   * @returns {}
   */
  throttle: function (func, threshold) {
    let throttling = false;
    const clear = () => {
      throttling = false;
    };
    const throttled = function () {
      if (!throttling) {
        func.apply(this, arguments); // this context bound on func
        globalThis.setTimeout(clear, threshold);
        throttling = true;
      }
    };
    return throttled;
  },

  noop: function () {}
};

modulum("FunctionHelper", function (context, cls) {
  cls.FunctionHelper = FunctionHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = FunctionHelper;
}
